module.exports = __webpack_public_path__ + "static/media/PATRON.be5ef649.mp4";